/**
 * Luxury Brand Category Icons
 * Minimal, elegant SVG icons inspired by luxury fashion brands
 */

// Men's Clothing Icon - Minimalist shirt/suit
export const MensClothingIcon = ({ size = 64, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Minimalist shirt/suit silhouette */}
    <path 
      d="M32 12L28 18H20C18.8954 18 18 18.8954 18 20V50C18 51.1046 18.8954 52 20 52H44C45.1046 52 46 51.1046 46 50V20C46 18.8954 45.1046 18 44 18H36L32 12Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Collar detail */}
    <path 
      d="M28 18L32 22L36 18" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Button detail (minimal) */}
    <circle cx="32" cy="30" r="1" fill={color} />
    <circle cx="32" cy="36" r="1" fill={color} />
  </svg>
);

// Women's Clothing Icon - Elegant dress silhouette
export const WomensClothingIcon = ({ size = 64, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Elegant dress silhouette */}
    <path 
      d="M32 12C32 12 28 16 28 20V24C28 25.1046 28.8954 26 30 26H34C35.1046 26 36 25.1046 36 24V20C36 16 32 12 32 12Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    <path 
      d="M32 26V52M24 52H40" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Waist detail */}
    <path 
      d="M26 30H38" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Sustainable/Eco Icon - Minimalist leaf
export const SustainableIcon = ({ size = 64, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Elegant leaf shape */}
    <path 
      d="M32 12C28 16 20 24 20 32C20 40 24 44 32 48C40 44 44 40 44 32C44 24 36 16 32 12Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Leaf vein */}
    <path 
      d="M32 12V48M32 32L20 24M32 32L44 24" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Premium/Exclusive Icon - Minimalist star/diamond
export const PremiumIcon = ({ size = 64, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Elegant diamond/star */}
    <path 
      d="M32 16L36 28L48 32L36 36L32 48L28 36L16 32L28 28L32 16Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Center point */}
    <circle cx="32" cy="32" r="2" fill={color} />
  </svg>
);

// Generic Category Icon - Minimalist box/package
export const CategoryIcon = ({ size = 64, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Minimalist package/box */}
    <path 
      d="M20 20L32 12L44 20V44L32 52L20 44V20Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    <path 
      d="M32 12V52M20 20L44 20" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Accessories Icon (watches, bags, eyewear)
export const AccessoriesIcon = ({ size = 64, color = '#1A1A1A' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Watch face */}
    <circle cx="32" cy="28" r="10" stroke={color} strokeWidth="2" fill="none" />
    <line x1="32" y1="28" x2="32" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="32" y1="28" x2="35" y2="31" stroke={color} strokeWidth="2" strokeLinecap="round" />
    
    {/* Watch band */}
    <rect x="29" y="18" width="6" height="4" rx="1" fill={color} />
    <rect x="29" y="38" width="6" height="4" rx="1" fill={color} />
    
    {/* Handbag */}
    <path
      d="M 16 45 L 16 52 C 16 54 17 55 19 55 L 29 55 C 31 55 32 54 32 52 L 32 45 Z"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <path d="M 20 45 L 20 42 C 20 40 21 39 24 39 C 27 39 28 40 28 42 L 28 45" 
      stroke={color} 
      strokeWidth="2" 
      fill="none" 
    />
    
    {/* Sunglasses */}
    <ellipse cx="42" cy="48" rx="6" ry="4" stroke={color} strokeWidth="2" fill="none" />
    <ellipse cx="54" cy="48" rx="6" ry="4" stroke={color} strokeWidth="2" fill="none" />
    <line x1="48" y1="48" x2="48" y2="48" stroke={color} strokeWidth="2" />
  </svg>
);

// Helper function to get icon by category key
export const getCategoryIcon = (categoryKey, size = 64, color = '#1A1A1A') => {
  const props = { size, color };
  
  switch (categoryKey) {
    case 'mens-clothing':
      return <MensClothingIcon {...props} />;
    case 'womens-clothing':
      return <WomensClothingIcon {...props} />;
    case 'accessories':
      return <AccessoriesIcon {...props} />;
    case 'sustainable':
    case 'eco':
      return <SustainableIcon {...props} />;
    case 'premium':
    case 'exclusive':
      return <PremiumIcon {...props} />;
    default:
      return <CategoryIcon {...props} />;
  }
};

